import { useState, useEffect, useRef } from "react";
import { request } from "hooks/useOkoApi/useOkoApi";

export const useTeacherSearch = (schoolId) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchError, setSearchError] = useState(null);
  const debounceRef = useRef(null);

  useEffect(() => {
    if (!searchTerm.trim()) {
      setSearchResults([]);
      return;
    }

    if (debounceRef.current) clearTimeout(debounceRef.current);

    debounceRef.current = setTimeout(async () => {
      setSearchLoading(true);
      setSearchError(null);
      try {
        const params = new URLSearchParams();
        params.append("role", "educator");
        if (schoolId) params.append("school_id", schoolId);
        params.append("search", searchTerm.trim());
        params.append("limit", "10");
        const response = await request(`admin/users?${params.toString()}`, { method: "GET" });
        setSearchResults(response.users || []);
      } catch {
        setSearchError("Failed to search educators.");
      } finally {
        setSearchLoading(false);
      }
    }, 300);

    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, [searchTerm, schoolId]);

  const clearSearch = () => {
    setSearchTerm("");
    setSearchResults([]);
    setSearchError(null);
  };

  return { searchTerm, setSearchTerm, searchResults, searchLoading, searchError, clearSearch };
};
